module.exports={Remove:"Supprimer"};